import React from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { arrangeData } from '@/middlewares/api';

import SelectField from '@/components/forms/select-field';
import DurationPickerField from '@/components/forms/duration-picker';
import { withFormikFieldAdapter as formikFieldAdapter } from '@/components/forms/formik-adapter';

const validationSchema = Yup.object().shape({
    category: Yup.string().required('Required').max(255, 'Max 255 characters'),
    media: Yup.string().required('Required').max(255, 'Max 255 characters'),
    featured_background: Yup.string().required('Required').max(255, 'Max 255 characters'),
    length_use: Yup.string()
        .required('Required')
        .matches(/^[0-9]{1,2}:[0-5][0-9]$/, 'Invalid duration format (mm:ss)'),
    term: Yup.string().required('Required').max(255, 'Max 255 characters'),
});

const SelectFieldFormik = formikFieldAdapter(SelectField);
const DurationPickerFieldFormik = formikFieldAdapter(DurationPickerField);

const UploadSyncStep3 = ({
    initialValues,
    syncCategories,
    syncMedias,
    syncFeaturedBackground,
    syncTerms,
    prevStep,
    nextStep,
    bgImg
}) => {
    return (
        <section className="upload-form__sec" style={bgImg}>
            <div className="content">
                <div className="upload-form__top">
                    <h2 className="head-shadow">CLEAR SYNC</h2>
                    <h3 className="head">
                        Step 3 of 4: Using Info
                    </h3>
                </div>
                <div className="form-step__body">
                    <Formik
                        initialValues={{
                            category: '',
                            media: '',
                            featured_background: '',
                            length_use: '00:00',
                            term: '',
                            ...initialValues
                        }}
                        validationSchema={validationSchema}
                        enableReinitialize={true}
                        onSubmit={(values) => {
                            const formData = arrangeData(values);
                            nextStep(formData, values);
                        }}
                    >
                        {({ values: currentValues, isSubmitting }) => (
                            <Form className="form-layout" noValidate>
                                <div className="form-row">
                                    <div className="form-col_2">
                                        <Field
                                            name="category"
                                            component={SelectFieldFormik}
                                            options={syncCategories}
                                            required={true}
                                            placeholder="Select Category"
                                            label="Category of Use"
                                            note="What type of production is your project? (Commercial, Trailer, Film, Video Game, TV Show, Social Media, etc.)"
                                        />
                                    </div>
                                    <div className="form-col_2">
                                        <Field
                                            name="media"
                                            required={true}
                                            component={SelectFieldFormik}
                                            options={syncMedias}
                                            placeholder="Select Media"
                                            label="Media"
                                            note="Media channels through which you wish to secure rights to release your project"
                                        />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-col_2">
                                        <Field
                                            name="featured_background"
                                            component={SelectFieldFormik}
                                            required={true}
                                            options={syncFeaturedBackground}
                                            placeholder="Select"
                                            label="Featured/Background"
                                            note="Describe the way in which the song will be presented."
                                        />
                                    </div>
                                    <div className="form-col_2">
                                        <Field
                                            name="length_use"
                                            component={DurationPickerFieldFormik}
                                            required={true}
                                            label="Length of Master Recording / Composition Use"
                                            note="State the length of the recording use in your project."
                                        />
                                    </div>
                                </div>
                                <Field
                                    name="term"
                                    component={SelectFieldFormik}
                                    options={syncTerms}
                                    placeholder="Select"
                                    label="Term"
                                    required={true}
                                    note="State how long you would like the rights to use the master recording in your project. NOTE: Rights in perpetuity allow the licensee to use the song in the project forever; HOWEVER, rights in perpetuity usually garner higher fees."
                                />
                                <div className="submit-row submit-row_txt">
                                    <button className="btn btn-second" onClick={() => prevStep(currentValues)}
                                        type="button">Back</button>
                                    <button
                                        className="btn-red-primary"
                                        disabled={isSubmitting}
                                        type="submit">Next</button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </section>
    );
};

export default UploadSyncStep3;
